import apiClient from "../api/axios";
import alertService from "../components/alert/alertService";
import { handleApiError } from "../api/handleApiError";
import {
  EcoEfficiencyDashboardMonthlyResults,
  EcoEfficiencyDashboardYearlyResults,
  EcoEfficiencyResponseV2,
  EcoEfficiencyV2,
} from "../models/dto/response/ResponseEcoEfficiencyV2";

export const ecoEfficiencyDashboardService = {
  getEcoEfficiency: async (): Promise<EcoEfficiencyV2[] | null> => {
    try {
      alertService.showLoading();
      const response = await apiClient.get("/v2/eco-efficiency");
      const temp: EcoEfficiencyResponseV2 = response.data;
      return temp.results.ecoEfficiencies;
    } catch (error: any) {
      handleError(error);
    } finally {
      alertService.closeLoading();
    }
    return null;
  },
  getEcoEffDataMonthly: async (
    ecoEfficiencyRefId: string,
    startDate: string,
    endDate: string
  ): Promise<EcoEfficiencyDashboardMonthlyResults | null> => {
    try {
      const response = await apiClient.post(
        `v2/eco-efficiency/dashboard/monthly/${ecoEfficiencyRefId}`,
        { startDate, endDate }
      );
      return response.data.results ?? null;
    } catch (error: any) {
      handleError(error);
    }
    return null;
  },
  getEcoEffDataYearly: async (
    ecoEfficiencyRefId: string
  ): Promise<EcoEfficiencyDashboardYearlyResults | null> => {
    try {
      const response = await apiClient.post(
        `v2/eco-efficiency/dashboard/yearly/${ecoEfficiencyRefId}`
      );
      return response.data.results ?? null;
    } catch (error) {
      handleError(error);
    }
    return null;
  },
  getEcoEffDataYearlySummary: async (
    indicatorRef: string,
    suborganizationRefs: string[],
    startYear: number,
    startMonth: number
  ): Promise<EcoEfficiencyDashboardYearlyResults | null> => {
    try {
      const response = await apiClient.post(
        `v2/eco-efficiency/dashboard/summary/yearly/${indicatorRef}`,
        { suborganizationRefs, startYear, startMonth }
      );
      return response.data.results ?? null;
    } catch (error) {
      handleError(error);
    }
    return null;
  },
  getEcoEffDataMonthlySummary: async (
    indicatorRef: string,
    suborganizationRefs: string[],
    startYear: number,
    startMonth: number
  ): Promise<EcoEfficiencyDashboardMonthlyResults | null> => {
    try {
      const response = await apiClient.post(
        `/v2/eco-efficiency/dashboard/summary/monthly/${indicatorRef}`,
        { suborganizationRefs, startYear, startMonth }
      );
      return response.data.results ?? null;
    } catch (error: any) {
      handleError(error);
    }
    return null;
  },
};

const handleError = (error: unknown) =>
  handleApiError(
    error,
    {
      VALIDATION_ERROR: {
        messageKey: (body) =>
          body.includes("Duplicate") ? "Component-Name-Duplicated" : "validation-failed",
        type: "error",
      },
      ECONOMIC_INDICATOR_ALREADY_EXISTS: "Economic-Indicator-Already-Exists",
      ENVIRONMENTAL_IMPACT_TYPES_RETRIEVE_FAILED:
        "Environmental-Impact-Types-Retrieve-Failed",
      BASE_YEAR_OPTIONS_RETRIEVE_FAILED: "Base-Year-Options-Retrieve-Failed",
      ECO_EFFICIENCY_ALREADY_EXISTS: "Eco-Efficiency-Already-Exists",
      FORBIDDEN_ACTION_ERROR: "Forbidden-Action-Error",
      FORBIDDEN_ECO_EFFICIENCY_ERROR: "Action-Not-Allowed-Upgrade-Required",
      FORBIDDEN_ECONOMIC_INDICATOR_ERROR: "Action-Not-Allowed-Upgrade-Required",
    },
  );
